export default __webpack_public_path__ + "static/inner-belief_cover-9d83633d36feabed70d1ea85235ad843.webp";